import { useCallback, useEffect } from 'react'
import { useComputed, useSignal } from '@preact/signals-react'
import { getSubmit } from '@ui-seeker/utils'
import { useToast } from '@hooks'
import { useReportBackendApiPath } from 'Pages/ReportsAlerts/Reports/@hooks/index'


export default function useInfoModalHistorical(idReport, rowData) {
	const { historic } = useReportBackendApiPath()
	const reportName = rowData?.name
	const officeOptions = useSignal(rowData?.pickUp.map(({ officeID, country, type, name }) => ({
		label: name, value: officeID, country, type
	})) || [])
	const offices = rowData?.pickUp

	const { showToast } = useToast()
	const officeSelected = useSignal(rowData?.pickUp[0].officeID)
	const historicalData = useSignal({})
	const isLoadingHistoricalData = useSignal(true)
	const historicalOfficeData = useComputed(() => historicalData.value[officeSelected.value] || [])

	const setOfficeSelected = useCallback(newValue => {
		officeSelected.value = newValue
	}, [idReport])

	useEffect(() => {
		getSubmit(historic, { idReport })
			.then(({ byOffices }) => historicalData.value = byOffices)
			.catch(() => showToast.error())
			.finally(() => isLoadingHistoricalData.value = false)
	}, [])

	return {
		reportName,
		numOffices: rowData?.pickUp.length,
		officeOptions,
		offices,
		isLoadingHistoricalData: isLoadingHistoricalData.value,
		historicalData: historicalData.value,
		historicalOfficeData: historicalOfficeData.value,
		idLastExecution: rowData?.idLastExecution,
		officeSelected: officeSelected.value,
		setOfficeSelected
	}
}